<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Mailing List</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" #form="ngForm">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="input-fields">
                <div>
                  <label for="newList">New List</label>
                  <input #newList id="newList" type="text"
                         style="border: 1px solid; border-radius: 3px"
                         [class.ng-invalid]="!validateName(newList.value) "/>
                  <span style="display:flex;justify-content: center">
                    <input type="image" src="/assets/img/create.svg"
                           *ngIf="!newList.classList.contains('ng-invalid')"
                           (click)="addList(newList.value); newList.value = ''"
                           title="Add new list" style="width:20px; padding: 0; border: 0"/>
                  </span>
                </div>
              </div>
            </div>
            <div class="fields__block__section" *ngIf="mailingList.length > 0">
              <div class="dropdown-fields">
                <div>
                  <label for="mailLists">List</label>
                  <select [(ngModel)]="selectedList" id="mailLists" name="mailLists">
                    <option *ngFor="let item of mailingList;let i = index"
                            [value]="i">{{item.name}}</option>
                  </select>
                </div>
              </div>

              <div class="table-fields" *ngIf="selectedList != null">
                <div style="height: 350px;overflow-y: auto;">
<!--                  <label class="full"></label>-->
                  <table>
                    <thead>
                    <tr>
                      <th scope="col" class="text-nowrap" style="width: 1%">Actions</th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr mdbTableCol *ngFor="let el of this.mailingList[selectedList]?.list; let i = index">
                      <td>
                        <div style="display: flex; justify-content: space-evenly">
                          <input type="image" src="/assets/img/edit-window-blue.svg" title="Edit"
                                 (click)="editEntry(selectedList, i)"
                                 style="width:20px; margin: 5px"/>
                          <input type="image" src="/assets/img/delete.svg" title="Delete"
                                 (click)="deleteEntry(selectedList, i)"
                                 style="width:20px; margin: 5px"/>
                        </div>
                      </td>
                      <ng-container *ngIf="selectedList == selectedEntry?.iList && i == selectedEntry?.i;else show">
                        <td style="align-content: center;">
                          <input type="text" [(ngModel)]="selectedEntry.entry.name" name="name"
                                 style="border: 1px solid; border-radius: 3px;text-align: center; width: 100%"
                                 [class.ng-invalid]="!validateName(selectedEntry.entry.name)">
                        </td>
                        <td style="align-content: center;">
                          <input type="text" [(ngModel)]="selectedEntry.entry.email" name="email"
                                 style="border: 1px solid; border-radius: 3px;text-align: center; width: 100%"
                                 [class.ng-invalid]="!validateEmail(selectedEntry.entry.email)">
                        </td>
                      </ng-container>
                      <ng-template #show>
                        <td style="align-content: center;">{{ el.name }}</td>
                        <td style="align-content: center;">{{ el.email }}</td>
                      </ng-template>
                    </tr>
                    <tr>
                      <td>
                        <div style="display: flex; justify-content: space-evenly">
                          <input type="image" src="/assets/img/create.svg" title="Edit"
                                 *ngIf="validateName(newName.value) && validateEmail(newEmail.value)"
                                 (click)="addEntry(selectedList, newName.value,  newEmail.value );
                                 newName.value = ''; newEmail.value = ''"
                                 style="width:20px; margin: 5px"/>
                        </div>
                      </td>
                      <td style="align-content: center;">
                        <input #newName id="name" type="text" name="name"
                               placeholder="example"
                               style="border: none;text-align: center; width: 100%"
                               [class.ng-invalid]="!validateName(newName.value)">
                      </td>
                      <td style="align-content: center;">
                        <input #newEmail id="email" type="text" name="email"
                               style="border: none;text-align: center; width: 100%"
                               placeholder="example@email.com"
                               [class.ng-invalid]="!validateEmail(newEmail.value) ">
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="fields__btn">
            <button type="submit" [ngClass]="form.form.valid ? 'blue' : 'gray'"
                    (click)="save()"
                    [disabled]="!form.form.valid">Save</button>

            <button
              type="submit" [ngClass]="form.form.valid ? 'blue' : 'gray'"
              (click)="deleteList()" *ngIf="selectedList != null"
              [disabled]="!form.form.valid">Delete List</button>

            <a class="gray" href="#" type="reset" value="Cancel">Cancel</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
